import classNames from 'classnames';
import React, { useMemo, useState } from 'react';
import EcoTitle, { EcoTitleProps } from 'eco-design/base/eco-title';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
// import 'swiper/css/pagination';
import './index.scss';
import EcoImg from 'eco-design/base/eco-img';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import { Navigation, Pagination } from 'swiper';
import gtm from 'eco-design-reliance/gtm';

export interface EcoTabImgsItem extends EcoTabItemProps {
    imgs: {
        pc?: string;
        pad?: string;
        h5?: string;
    }[];
}

export interface EcoTabImgsProps {
    className?: string;
    theme?: 'white' | 'black';
    title?: EcoTitleProps['title'];
    items?: EcoTabImgsItem[];
}

/**
 * 维护: hzih.huang(黄子豪)
 * 描述: tab多图切换
 */
const DEFAULT_ITEMS: EcoTabImgsProps['items'] = [];
const EcoTabImgs: React.FC<EcoTabImgsProps> = ({ className, title, theme = 'white', items = DEFAULT_ITEMS }) => {
    const prefixCls = `eco-tab-imgs`;
    const classes = classNames(prefixCls, 'GtmModuleData-section', className);

    const [active, setActive] = useState(0);
    const imgs = useMemo(() => items[active].imgs, [active, items]);
    const toggleItemHandle = (_item: EcoTabItemProps, index: number) => {
        setActive(index);
    };

    const handleGtm = (type: 'left' | 'right') => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: title || 'none',
            button_name: type === 'left' ? 'Left switch' : 'Right switch',
            __btn_id1: `${prefixCls}-swiper-${type === 'left' ? 'prev' : 'next'}`,
            __btn_id2: `${type === 'left' ? '<' : '>'}`,
            __btn_type: 'text',
        });
    };
    return (
        <div className={classes} data-section-id="EcoTabImgs">
            {title && <EcoTitle className={`${prefixCls}-title`} title={title} />}
            {items.length > 0 && (
                <div className={`${prefixCls}-swiper-container`}>
                    <Swiper
                        className={`${prefixCls}-swiper`}
                        loop={imgs.length > 1}
                        navigation={{
                            nextEl: `.${prefixCls}-swiper-next`,
                            prevEl: `.${prefixCls}-swiper-prev`,
                        }}
                        pagination={{
                            el: `.${prefixCls}-swiper-pagination`,
                            clickable: true,
                        }}
                        modules={[Navigation, Pagination]}
                    >
                        {imgs.map((i, idx) => (
                            <SwiperSlide key={idx}>
                                <EcoImg {...i} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    {imgs.length > 1 && (
                        <>
                            <div className={`${prefixCls}-swiper-prev GtmModuleData-btn-text`} onClick={() => handleGtm('left')}>
                                <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                            </div>
                            <div className={`${prefixCls}-swiper-next GtmModuleData-btn-text`} onClick={() => handleGtm('right')}>
                                <EcoIconSwiperArrow className="eco-swiper-button-icon" />
                            </div>

                            <div className={`${prefixCls}-swiper-pagination`}></div>
                        </>
                    )}
                </div>
            )}
            {items.length > 0 && (
                <div className={`${prefixCls}-tab`}>
                    <EcoTab onChange={toggleItemHandle} gtmTitle={title as string} items={items} theme={theme} />
                </div>
            )}
        </div>
    );
};

export default EcoTabImgs;
